import React, { useEffect, useRef, useState } from "react";
import Navbar from "../../components/Navbar";
import Styles from "../../styles/session/createnewformat.module.scss";
import Swal from "sweetalert2";
import { Link, useNavigate } from "react-router-dom";
import { adminRoutes } from "../../routers/AdminRouters";
import { useSelector, useDispatch } from "react-redux";
import { toggle, updateSessionData } from "../../redux";
import { addFormat, getOptions } from "../../services";
import Close_Button from "../../assets/auth/close.png";
import Nomore from "../../assets/session/no-more.png";
import Success from "../../assets/session/success.png";
function secondsToHhmmss(totalSeconds) {
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;
  return [hours, minutes, seconds]
    .map((unit) => String(unit).padStart(2, "0"))
    .join(":");
}
// Convert HH:MM:SS to seconds
function hhmmssToSeconds(hhmmss) {
  if (typeof hhmmss !== "string") {
    console.error("Invalid time format received:", hhmmss);
    return 0; // Return a default value or handle it accordingly
  }

  const [hours, minutes, seconds] = hhmmss.split(":").map(Number);
  return (hours || 0) * 3600 + (minutes || 0) * 60 + (seconds || 0);
}

const CreateNewFormat = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { sessionDetails, formats, sessionData } = useSelector(
    (state) => state.sessionFormats
  );
  const { options } = useSelector((state) => state.exercises);

  const droppedExercises = sessionData?.droppedExercises || [];
  const isSidebarOpen = useSelector((state) => state.navbar.button);
  const [isSubmitting, setIsSubmitting] = useState(false); 
  useEffect(() => {
    getOptions();
  }, []);
    const handleMainContainerClick = () => {
      if (isSidebarOpen) {
        dispatch(toggle());
      }
    };
  const sessionId = sessionData?.sessionId || "";
  const updateDroppedExercise = (index, parentField, field, value) => {
    const updatedExercises = droppedExercises.map((exercise, idx) =>
      idx === index
        ? {
            ...exercise,
            ...(parentField
              ? {
                  [parentField]: {
                    ...exercise[parentField],
                    [field]: value,
                  },
                }
              : { [field]: value }),
          }
        : exercise
    );

    dispatch(
      updateSessionData({
        ...sessionData,
        droppedExercises: updatedExercises,
      })
    );
  };


  const handleSave = async () => {
    if (isSubmitting) return; // Prevent multiple clicks
  
    setIsSubmitting(true);
    try {
      const formData = {
        session: sessionDetails.sessionId,
        format: formats.formatId,
        subFormat: formats.subFormat,
        restTime: formats.restPeriods,
        restPeriodDetails: formats.restPeriodDetails,
        exercises: droppedExercises.map((exercise) => ({
          exercise: exercise._id,
          variables: {
            sets: exercise.variables?.sets || 0,
            reps: exercise.variables?.reps || 0,
            tempos: exercise.variables?.tempos || 0,
            cals: exercise.variables?.cals || 0,
            meters: exercise.variables?.meters || 0,
            time: exercise.variables?.time,
          },
          times: {
            blockTimings: exercise.times?.blockTimings || 0,
            workPeriods: exercise.times?.workPeriods || 0,
            restPeriods: exercise.times?.restPeriods || 0,
          },
        })),
      };

      const success = await addFormat(formData);

      if (success===true) {
        Swal.fire({
          html: `
            <div style="text-align: center; border-radius: 20px; position: relative; padding: 30px;">
              <button 
            id="customCloseButton" 
            style="position: absolute; top:-10px; right:-20px; background: none; border: none; cursor: pointer;">
            <img 
            src=${Close_Button} 
              alt="Close" 
              style="width: 50px; height: 50px;"
            />
          </button>
              <img 
                src=${Success} 
                alt="Warning" 
                style="width: 100px; margin-bottom: 20px;" 
              />
              <p style="color: #151515; text-align:center; font-family:gothambold; font-size:24px;">
              Exercises successfully added to format
              </p>
              <button 
                id="backButton" 
                style="background: white; color: #151515;  padding: 15px 20px; font-family:gothambold; border-radius: 8px; cursor: pointer; margin-top: 30px;border: 1px solid #E27808;width:250px;height:48px;font-size:14px;">
                Close
              </button>
            </div>
          `,
          showConfirmButton: false,
          width: "500px",
          customClass: {
            popup: "custom-swal-container",
          },
          didOpen: () => {
            const backButton = document.getElementById("backButton");
            const closeButton = document.getElementById("customCloseButton");

            backButton.addEventListener("click", () => {
              Swal.close();
            });

            closeButton.addEventListener("click", () => {
              Swal.close();
            });
          },
        });
        navigate(adminRoutes.listFormat.replace(":sessionId",sessionId));
      }
    } catch (error) {
      console.error("Error in handleSave:", error);

      Swal.fire({
        html: `
          <div style="text-align: center; border-radius: 20px; position: relative; padding: 30px;">
            <button 
          id="customCloseButton" 
          style="position: absolute; top:-10px; right:-20px; background: none; border: none; cursor: pointer;">
          <img 
          src=${Close_Button} 
            alt="Close" 
            style="width: 50px; height: 50px;"
          />
        </button>
            <img 
              src=${Nomore} 
              alt="Warning" 
              style="width: 100px; margin-bottom: 20px;" 
            />
            <p style="color: #151515; text-align:center; font-family:gothambold; font-size:24px;">
       An error occurred while saving the format.
            </p>
            <button 
              id="backButton" 
              style="background: white; color: #151515;  padding: 15px 20px; font-family:gothambold; border-radius: 8px; cursor: pointer; margin-top: 30px;border: 1px solid #E27808;width:250px;height:48px;font-size:14px;">
              Close
            </button>
          </div>
        `,
        showConfirmButton: false,
        width: "500px",
        customClass: {
          popup: "custom-swal-container",
        },
        didOpen: () => {
          const backButton = document.getElementById("backButton");
          const closeButton = document.getElementById("customCloseButton");

          backButton.addEventListener("click", () => {
            Swal.close();
          });

          closeButton.addEventListener("click", () => {
            Swal.close();
          });
        },
      });
    }finally {
      setIsSubmitting(false); 
    }
  };

  const handleDeleteExercise = (index) => {
    const updatedExercises = [...droppedExercises];
    updatedExercises.splice(index, 1);

    dispatch(
      updateSessionData({
        ...sessionData,
        droppedExercises: updatedExercises,
      })
    );
  };

  const handleBack = () => {
    navigate(
      adminRoutes.assignFormatSecond.replace(":sessionId", formats.formatId)
    );
  };
  const handleCancel = () => {
    navigate(adminRoutes.listFormat.replace(":sessionId", sessionDetails.sessionId));
  };
  return (
    <>
      <Navbar />
      <div className={Styles.format_list_container}  onClick={handleMainContainerClick}>
        <h2>
          <Link to={adminRoutes.dashboard} className={Styles.dark}>
            HOME /
          </Link>{" "}
          <span className={Styles.orange}> CREATE NEW FORMAT</span>
        </h2>

        <div className={Styles.table_container_main}>
          <div className={Styles.table_container}>
            <div className={Styles.table_container_heading}>
              {/* <div className={Styles.table_container_headingone}> */}
                <h3>CREATE NEW FORMAT</h3>
              {/* </div> */}
              <div className={Styles.table_container_headingtwo}>
                <div className={Styles.create_new_assign}>
                  <h6>Session Name</h6>
                  <p>{sessionDetails.name}</p>
                </div>
              </div>
            </div>
            <div className={Styles.seperator}>
              <hr className={Styles.line} />
            </div>
          </div>
          <div className={Styles.progress_indicator}>
            <div className={Styles.progress_line}>
              <div className={`${Styles.step} ${Styles.active}`}>
                <div className={Styles.circle}></div>
              </div>
              <div className={`${Styles.line} ${Styles.active}`}></div>
              <div className={`${Styles.step} ${Styles.active}`}>
                <div className={Styles.circle}></div>
              </div>
              <div className={`${Styles.line} ${Styles.inactive}`}></div>
              <div className={`${Styles.step} ${Styles.inactive}`}>
                <div className={Styles.circle}></div>
              </div>
            </div>
            <div className={Styles.label}>Enter Exercises Details</div>
          </div>
          <div className={Styles.exercise_table}>
            <table>
              <thead className={Styles.table_heading}>
                <tr>
                  <th
                    style={{
                      backgroundColor: "transparent",
                      border: "1px solid  #262626",
                    }}
                  ></th>
                  <th
                    style={{
                      backgroundColor: "transparent",
                      borderLeft: "1px solid  #262626",
                      borderRight: "none",
                    }}
                  >
                    VARIABLE
                  </th>
                  <th
                    style={{
                      backgroundColor: "transparent",
                      border: "none",
                    }}
                  ></th>
                  <th
                    style={{
                      backgroundColor: "transparent",
                      border: "none",
                    }}
                  ></th>
                  <th
                    style={{
                      backgroundColor: "transparent",
                      border: "none",
                    }}
                  ></th>
                  <th
                    style={{
                      backgroundColor: "transparent",
                      border: "none",
                    }}
                  ></th>
                  <th
                    style={{
                      backgroundColor: "transparent",
                      border: "none",
                    }}
                  ></th>
                  <th
                    style={{
                      backgroundColor: "transparent",
                      borderLeft: "1px solid  #262626",
                      borderRight: "none",
                    }}
                  >
                    TIME
                  </th>
                  <th
                    style={{
                      backgroundColor: "transparent",
                      border: "none",
                    }}
                  ></th>
                  <th
                    style={{
                      backgroundColor: "transparent",
                      border: "none",
                    }}
                  ></th>
                  <th
                    style={{
                      backgroundColor: "transparent",
                      border: "none",
                    }}
                  ></th>
                </tr>
                <tr>
                  <th>Exercise Name</th>
                  <th>Sets</th>
                  <th>Reps</th>
                  <th>Tempo</th>
                  <th>Calories</th>
                  <th>Meters</th>
                  <th>Time</th>
                  <th>Block Timings</th>
                  <th>Work Periods</th>
                  <th>Rest Periods</th>
                  <th>Action</th>
                </tr>
              </thead>

              <tbody>
                {Array.isArray(droppedExercises) &&
                droppedExercises.length > 0 ? (
                  droppedExercises.map((exercise, index) => (
                    <tr key={exercise._id}>
                      <td>{exercise.name || ""}</td>

                      <td>
                        <select className={Styles.dropdown_select}
                          value={exercise.variables?.sets ?? 0}
                          onChange={(e) =>
                            updateDroppedExercise(
                              index,
                              "variables",
                              "sets",
                              e.target.value
                            )
                          }
                        >
                          <option value="0">0</option>
                          {options?.sets?.filter(set => set !== 0 && set !== "0").map((set) => (
                            <option key={set} value={set}>
                              {set}
                            </option>
                          ))}
                        </select>
                      </td>
                      <td>
                        <select className={Styles.dropdown_select}
                          value={exercise.variables?.reps ?? 0}
                          onChange={(e) =>
                            updateDroppedExercise(
                              index,
                              "variables",
                              "reps",
                              e.target.value
                            )
                          }
                        >
                          <option value="0">0</option>
                          {options?.reps?.filter(item => item !== 0 && item !== "0").map((item, index) => (
                            <option key={index} value={item}>
                              {item === -1 ? "Max" : item}
                            </option>
                          ))}
                        </select>
                      </td>
                      <td>
                        <select className={Styles.dropdown_select}
                          value={exercise.variables?.tempos ?? 0}
                          onChange={(e) =>
                            updateDroppedExercise(
                              index,
                              "variables",
                              "tempos",
                              e.target.value
                            )
                          }
                        >
                          <option value="0">0</option>
                          {options?.tempos?.filter(tempo => tempo !== 0 && tempo !== "0").map((tempo) => (
                            <option key={tempo} value={tempo}>
                              {tempo}
                            </option>
                          ))}
                        </select>
                      </td>
                      <td>
                        <select className={Styles.dropdown_select}
                          value={exercise.variables?.cals ?? 0}
                          onChange={(e) =>
                            updateDroppedExercise(
                              index,
                              "variables",
                              "cals",
                              e.target.value
                            )
                          }
                        >
                          <option value="0">0</option>
                          {options?.cals?.filter(cal => cal !== 0 && cal !== "0").map((cal) => (
                            <option key={cal} value={cal}>
                              {cal}
                            </option>
                          ))}
                        </select>
                      </td>
                      <td>
                        <select className={Styles.dropdown_select}
                          value={exercise.variables?.meters ?? 0}
                          onChange={(e) =>
                            updateDroppedExercise(
                              index,
                              "variables",
                              "meters",
                              e.target.value
                            )
                          }
                        >
                          <option value="0">0</option>
                          {options?.meters?.filter(item => item !== 0 && item !== "0").map((item, index) => (
                            <option key={index} value={item}>
                              {item === -1 ? "Max" : item}
                            </option>
                          ))}
                        </select>
                      </td>

                      <td>
                        <input
                          type="text"
                          value={secondsToHhmmss(
                            exercise.variables?.time || ""
                          )}
                          onChange={(e) =>
                            updateDroppedExercise(
                              index,
                              "variables",
                              "time",
                              hhmmssToSeconds(e.target.value)
                            )
                          }
                          onKeyDown={(e) => {
                            if (e.key === '-') {
                              e.preventDefault();
                            }
                          }}
                        />
                        
                      </td>
                      <td>
                        <select className={Styles.dropdown_select}
                          value={exercise.times?.blockTimings || ""}
                          onChange={(e) =>
                            updateDroppedExercise(
                              index,
                              "times",
                              "blockTimings",
                              e.target.value
                            )
                          }
                        >
                          <option value={exercise.times?.blockTimings || ""}>
                            {exercise.times?.blockTimings
                              ? exercise.times.blockTimings >= 90
                                ? `${
                                    exercise.times.blockTimings / 60
                                  } minute(s)`
                                : `${exercise.times.blockTimings} second(s)`
                              : "Choose from list"}
                          </option>
                          {options?.blockTimings
                            ?.filter(
                              (timing) =>
                                timing !== exercise.times?.blockTimings
                            )
                            .map((timing) => (
                              <option key={timing} value={timing}>
                                {timing >= 90
                                  ? `${timing / 60} minute(s)`
                                  : `${timing} second(s)`}
                              </option>
                            ))}
                        </select>
                      </td>

                      <td>
                        <select className={Styles.dropdown_select}
                          value={exercise.times?.workPeriods || ""}
                          onChange={(e) =>
                            updateDroppedExercise(
                              index,
                              "times",
                              "workPeriods",
                              e.target.value
                            )
                          }
                        >
                          <option value={exercise.times?.workPeriods || ""}>
                            {exercise.times?.workPeriods
                              ? exercise.times.workPeriods >= 90
                                ? `${exercise.times.workPeriods / 60} minute(s)`
                                : `${exercise.times.workPeriods} second(s)`
                              : "Choose from list"}
                          </option>
                          {options?.workPeriods
                            ?.filter(
                              (period) => period !== exercise.times?.workPeriods
                            )
                            .map((period) => (
                              <option key={period} value={period}>
                                {period >= 90
                                  ? `${period / 60} minute(s)`
                                  : `${period} second(s)`}
                              </option>
                            ))}
                        </select>
                      </td>

                      <td>
                        <select className={Styles.dropdown_select}
                          value={exercise.times?.restPeriods || ""}
                          onChange={(e) =>
                            updateDroppedExercise(
                              index,
                              "times",
                              "restPeriods",
                              e.target.value
                            )
                          }
                        >
                          <option value={exercise.times?.restPeriods || ""}>
                            {exercise.times?.restPeriods
                              ? exercise.times.restPeriods >= 90
                                ? `${exercise.times.restPeriods / 60} minute(s)`
                                : `${exercise.times.restPeriods} second(s)`
                              : "Choose from list"}
                          </option>
                          {options?.restPeriods
                            ?.filter(
                              (period) => period !== exercise.times?.restPeriods
                            )
                            .map((period) => (
                              <option key={period} value={period}>
                                {period >= 90
                                  ? `${period / 60} minute(s)`
                                  : `${period} second(s)`}
                              </option>
                            ))}
                        </select>
                      </td>
                      <td>
                        <button
                          className={Styles.delete_button}
                          onClick={() => handleDeleteExercise(index)}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                          >
                            <path
                              d="M21 5.25H17.441C16.54 5.25 16.502 5.136 16.255 4.396L16.053 3.789C15.746 2.869 14.889 2.25 13.919 2.25H10.081C9.11099 2.25 8.253 2.868 7.947 3.789L7.745 4.396C7.498 5.137 7.46 5.25 6.559 5.25H3C2.586 5.25 2.25 5.586 2.25 6C2.25 6.414 2.586 6.75 3 6.75H4.298L5.065 18.249C5.213 20.474 6.57701 21.75 8.80701 21.75H15.194C17.423 21.75 18.787 20.474 18.936 18.249L19.703 6.75H21C21.414 6.75 21.75 6.414 21.75 6C21.75 5.586 21.414 5.25 21 5.25ZM9.37 4.263C9.473 3.956 9.75799 3.75 10.081 3.75H13.919C14.242 3.75 14.528 3.956 14.63 4.263L14.832 4.87C14.876 5.001 14.92 5.128 14.968 5.25H9.03C9.078 5.127 9.12301 5 9.16701 4.87L9.37 4.263ZM17.438 18.149C17.343 19.582 16.629 20.25 15.193 20.25H8.806C7.37 20.25 6.657 19.583 6.561 18.149L5.801 6.75H6.558C6.683 6.75 6.787 6.737 6.899 6.729C6.933 6.734 6.964 6.75 6.999 6.75H16.999C17.035 6.75 17.065 6.734 17.099 6.729C17.211 6.737 17.315 6.75 17.44 6.75H18.197L17.438 18.149ZM14.75 11V16C14.75 16.414 14.414 16.75 14 16.75C13.586 16.75 13.25 16.414 13.25 16V11C13.25 10.586 13.586 10.25 14 10.25C14.414 10.25 14.75 10.586 14.75 11ZM10.75 11V16C10.75 16.414 10.414 16.75 10 16.75C9.586 16.75 9.25 16.414 9.25 16V11C9.25 10.586 9.586 10.25 10 10.25C10.414 10.25 10.75 10.586 10.75 11Z"
                              fill="#F79328"
                            />
                          </svg>
                        </button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="11" style={{ textAlign: "center" }}>
                      No exercises added.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
          <div className={Styles.seperator}>
            <hr className={Styles.line} />
          </div>
          <div className={Styles.button_group}>
            <button
              className={`${Styles.button} ${Styles.save_button}`}
              onClick={handleSave}
            >
              save
            </button>
            <button
              className={`${Styles.button} ${Styles.back_button}`}
              onClick={() => handleBack()}
            >
              Back
            </button>
            <button
              className={`${Styles.button} ${Styles.cancel_button}`}
              onClick={() => handleCancel()}
            >
              Cancel
            </button>
          </div>{" "}
        </div>
      </div>
    </>
  );
};

export default CreateNewFormat;
